/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect } from "react";
// import cssClasses from './Dashboard.module.css'
import cssClasses from "./DailyReport.module.css";
import { useState } from "react";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { TabContext, TabPanel } from "@mui/lab";
import SearchBar from "../../Subcomponents/Search";
import checked from "../../Assets/Images/Common/checked.svg";
import CustomAutoComplete from "../../Subcomponents/CustomAutoComplete";
import TabsMenu from "../../Subcomponents/TabsMenu";

import axios from "axios";
import MobileDateComponent from "../../Subcomponents/MobileDateComponent";
import { supabase } from "../../supabaseClient";
import debounce from "lodash.debounce";
import Button from "../../Subcomponents/Button";
import PayloadModal from "../../Modals/PayloadModal/PayloadModal";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate, useParams } from "react-router-dom";
import MultiSelectDropDown from "../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown";
import { getAPILogs, getAPICount } from "../../Services/APIReport";

import ClickAwayListener from "@mui/material/ClickAwayListener";
import { findIndex, orderBy } from "lodash";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function DailyReports() {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, "0");
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = currentDate.getFullYear();

  const formattedDate = `${year}-${month}-${day}`;

  // const [DailyReportDate, setDailyReportDate] = useState("2023-09-27");

  const [DailyReportDate, setDailyReportDate] = useState(formattedDate);
  const [navigateTab, setNavigateTab] = useState("");
  const [navigateSubTab, setNavigateSubTab] = useState("");
  const [tabValue, setTabValue] = useState(
    navigateTab !== "" ? navigateTab : ""
  );
  const [subTabValue, setSubTabValue] = useState(
    navigateSubTab !== "" ? navigateSubTab : ""
  );
  const [tabs, setTabs] = useState([]);
  const [dailyReports, setDailyReports] = useState([]);
  const [APIData, setAPIData] = useState([]);
  const [paymentAPI, setPaymentAPI] = useState([]);
  const [paymentBRS, setPaymentBRS] = useState([]);
  const [settlementAPIData, setSettlementAPIData] = useState([]);
  const [settlementBRSData, setSettlementBRSData] = useState([]);
  const [sendPayloadData, setSendPayloadData] = useState({});
  const [filteredBrsSuccessAPIArray, setFilteredBrsSuccessAPIArray] = useState(
    []
  );
  const [filteredSuccessArray, setFilteredSuccessArray] = useState([]);
  const [filteredErrorArray, setFilteredErrorArray] = useState([]);
  const [filteredBrsErrorArray, setFilteredBrsErrorArray] = useState([]);
  const [filteredVjPendingArray, setFilteredVjPendingArray] = useState([]);
  const [filteredLandownerArray, setFilteredLandownerArray] = useState([]);

  const [closedDate, setClosedDate] = useState(Date.now());
  const [subTabs, setSubTabs] = useState([]);
  const [helperText, setHelperText] = useState({
    title: "",
    startDateTime: "",
    endDateTime: "",
  });
  // const [selectedProject, setSelectedProject] = useState('ALL')
  // const [projects, setProjects] = useState([])
  const [lead, setLead] = useState("");
  const [showPayloadModal, setShowPayloadModal] = useState(false);
  const [selectedAPIType, setSelectedAPIType] = useState([]);
  const [selectedRazorPayType, setSelectedRazorPayType] = useState([]);
  const [selectedSettlementType, setSelectedSettlementType] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [projectId, setProjectId] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [DropdownProjectSearch, setDropDownProjectSearch] = useState("");
  const [DropdownErrorMessageSearch, setDropDownErrorMessageSearch] =
    useState("");
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [showAllProjectsDropDown, setShowAllProjectsDropDown] = useState(false);
  const [allProjectsDropDown, setAllProjectsDropDown] = useState([]);
  const [allErrorMessageDropDown, setAllErrorMessageDropDown] = useState([]);
  const [selectedErrorMessages, setSelectedErrorMessages] = useState([]);
  const [showAllErrorMessageDropDown, setShowAllErrorMessageDropDown] =
    useState(false);
  const [listOfDropDown, setListOfDropDown] = useState([
    // "Type of Lead",
    { label: "None", select: true },
    { label: "Project", select: false },
    { label: "Error Message", select: false },
  ]);

  const navigate = useNavigate();
  const { tab, subTab, type } = useParams();
  const paramAPIFilter = selectedAPIType?.map((el) => el.name).join("&&");
  const paramRazorPayFilter = selectedRazorPayType
    ?.map((el) => el.name)
    .join("&&");
  const paramSettlementFilter = selectedSettlementType
    ?.map((el) => el.name)
    .join("&&");

  function getURL() {
    if (window.location.pathname.includes("home")) {
      return "/home/APIDailyReports";
    } else {
      return "/APIDailyReports";
    }
  }

  async function getDailyReport() {
    const postData =
      projectId.length > 0
        ? Object(
          lead === ""
            ? {
              date: DailyReportDate,
              projectId: projectId,
            }
            : {
              date: DailyReportDate,
              projectId: projectId,
              // "leadName": lead
            }
        )
        : Object(
          lead === ""
            ? {
              date: DailyReportDate,
            }
            : {
              date: DailyReportDate,
              // "leadName": lead
            }
        );

    presentLoader();

    getAPICount(postData)
      .then((res) => {
        setDailyReports(res.data);

        const types =
          tabValue === "API"
            ? [
              {
                id: "JV",
                name: "JV",
                filter: "cp",
              },
              {
                id: "CustomerLedger",
                name: "CustomerLedger",
                filter: "cp",
              },
              {
                name: "100B2b",
                id: "100B2b",
                filter: "cp",
              },
              {
                name: "gstB2b",
                id: "gstB2b",
                filter: "cp",
              },
              {
                name: "sdrB2b",
                id: "sdrB2b",
                filter: "cp",
              },
              {
                name: "ApplicationApi",
                id: "ApplicationApi",
                filter: "cp",
              },
              {
                name: "100AMR",
                id: "100AMR",
                filter: "cp",
              },
              {
                name: "gstAMR",
                id: "gstAMR",
                filter: "cp",
              },
              {
                name: "gstAMRBrs",
                id: "gstAMRBrs",
                filter: "cp",
              },
              {
                name: "100AMRBrs",
                id: "100AMRBrs",
                filter: "cp",
              },
            ]
            : tabValue === "RazorPay To Token"
              ? [
                {
                  id: "paymentReceivedInRazorpay",
                  name: "paymentReceivedInRazorpay",
                  filter: "cp",
                },
                {
                  id: "paymentReceivedInRazorpayBrs",
                  name: "paymentReceivedInRazorpayBrs",
                  filter: "cp",
                },
              ]
              : tabValue === "Daily Settlement"
                ? [
                  {
                    id: "Settlement",
                    name: "Settlement",
                    filter: "cp",
                  },
                  {
                    id: "SettlementBrs",
                    name: "SettlementBrs",
                    filter: "cp",
                  },
                ]
                : [];
        setTypeList(types);

        dismissLoader();
      })
      .catch((err) => {
        console.error(err);
        dismissLoader();
      });
  }

  async function getAPIData() {
    // getDailyReport()
    presentLoader();
    if (true) {
      setFilteredLandownerArray([]);
      setFilteredVjPendingArray([]);
      setFilteredBrsErrorArray([]);
      setFilteredErrorArray([]);

      const newType =
        selectedAPIType.length !== 0
          ? selectedAPIType?.map((el) => el.name)
          : [
            "JV",
            "CustomerLedger",
            "100B2b",
            "gstB2b",
            "sdrB2b",
            "ApplicationApi",
            "100AMR",
            "gstAMR",
            "gstAMRBrs",
            "100AMRBrs",
          ];

      const postData =
        projectId.length > 0
          ? Object(
            lead === ""
              ? {
                date: DailyReportDate,
                type: newType,
                projectId: projectId,
              }
              : {
                date: DailyReportDate,
                type: newType,
                projectId: projectId,
                leadName: lead,
              }
          )
          : Object(
            lead === ""
              ? {
                date: DailyReportDate,
                type: newType,
              }
              : {
                date: DailyReportDate,
                type: newType,
                leadName: lead,
              }
          );

      getAPILogs(postData)
        .then((res) => {
          setAPIData(res.data);

          const errorArrayData = Object.values(res.data)
            ?.map((data) => data.Error)
            ?.flat();

          const filteredErrors = [];
          for (const errorObj of errorArrayData) {
            for (const errorMsg of errorMessages) {
              if (errorObj.errorMsg.includes(errorMsg)) {
                filteredErrors.push(errorObj);
              }
            }
          }

          const errorArray =
            errorMessages.length > 0 ? filteredErrors : errorArrayData;
          const ErrorAPIObject = Object.freeze({
            VJ: "VJ",
            Landowner: "Landowner",
          });
          const vjPendingEnum = Object.freeze({
            eBankingErr: "Could not find Entry in Finance.EBankingDetail",
          });

          const landowner = [];
          const vjPendingArray = [];
          const APIErr = [];

          for (let key of errorArray) {
            if (key.owner === ErrorAPIObject.Landowner) {
              landowner.push(key);
            } else if (key?.errorObj?.err === vjPendingEnum.eBankingErr) {
              vjPendingArray.push(key);
            } else {
              APIErr.push(key);
            }
          }

          const successArray = Object.values(res.data)
            ?.map((data) => data.Success)
            ?.flat()
            .filter((el) => el.type !== "100AMRBrs" && el.type !== "gstAMRBrs");

          setFilteredSuccessArray(successArray);

          const brsSuccessAPIArray = [
            ...(res.data["100AMRBrs"]?.Success || []),
            ...(res.data["gstAMRBrs"]?.Success || []),
          ].flat();

          setFilteredBrsSuccessAPIArray(brsSuccessAPIArray);

          setFilteredErrorArray(APIErr);

          const brsErrorAPIArray = [
            ...(APIData["100AMR"]?.BrsError || []),
            ...(APIData["gstAMR"]?.BrsError || []),
          ].flat();

          setFilteredBrsErrorArray(brsErrorAPIArray);

          setFilteredVjPendingArray(vjPendingArray);

          setFilteredLandownerArray(landowner);

          dismissLoader();
        })
        .catch((err) => {
          console.error(err);
          dismissLoader();
        });
    }
  }

  async function getRazorPayData() {
    if (tabValue === "RazorPay To Token") {
      const newType =
        selectedRazorPayType.length !== 0
          ? selectedRazorPayType?.map((el) => el.name)
          : ["paymentReceivedInRazorpay", "paymentReceivedInRazorpayBrs"];

      const postData =
        projectId.length > 0
          ? Object(
            lead === ""
              ? {
                date: DailyReportDate,
                type: newType,
                projectId: projectId,
              }
              : {
                date: DailyReportDate,
                type: newType,
                projectId: projectId,
                leadName: lead,
              }
          )
          : Object(
            lead === ""
              ? {
                date: DailyReportDate,
                type: newType,
              }
              : {
                date: DailyReportDate,
                type: newType,
                leadName: lead,
              }
          );
      presentLoader();

      getAPILogs(postData)
        .then((res) => {
          // const filterByErrorMsgAPI = errorMessages.length > 0 ? res.data.paymentrecievedAPI.filter(el=> errorMessages.includes(el?.errorMsg)) : res.data.paymentrecievedAPI

          // const filterByErrorMsgAPIBRS = errorMessages.length > 0 ?res.data.paymentrecievedAPIBRS.filter(el=> errorMessages.includes(el?.errorMsg)) : res.data.paymentrecievedAPIBRS

          //   setPaymentAPI(filterByErrorMsgAPI)

          //   setPaymentBRS(filterByErrorMsgAPIBRS)

          setPaymentAPI(res.data.paymentrecievedAPI);

          setPaymentBRS(res.data.paymentrecievedAPIBRS);

          dismissLoader();
        })
        .catch((err) => {
          console.error(err);
          dismissLoader();
        });
    }
  }

  async function getSettlementData() {
    if (tabValue === "Daily Settlement") {
      const newType =
        selectedSettlementType.length !== 0
          ? selectedSettlementType?.map((el) => el.name)
          : ["SettlementBrs", "Settlement"];

      const postData =
        projectId.length > 0
          ? Object(
            lead === ""
              ? {
                date: DailyReportDate,
                type: newType,
                projectId: projectId,
              }
              : {
                date: DailyReportDate,
                type: newType,
                projectId: projectId,
                leadName: lead,
              }
          )
          : Object(
            lead === ""
              ? {
                date: DailyReportDate,
                type: newType,
              }
              : {
                date: DailyReportDate,
                type: newType,
                leadName: lead,
              }
          );
      presentLoader();

      getAPILogs(postData)
        .then((res) => {
          setSettlementAPIData(res.data.paymentsettledAPI);
          setSettlementBRSData(res.data.paymentsettledAPIBRS);

          dismissLoader();
        })
        .catch((err) => {
          console.error(err);
          dismissLoader();
        });
    }
  }

  function clearFilters() {
    setListOfDropDown((pre) => {
      pre = pre?.map((m) => ({
        ...m,
        select: false,
      }));
      pre[0].select = true;
      return [...pre];
    });

    setAllProjectsDropDown((pre) => {
      pre = pre?.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });

    setAllErrorMessageDropDown((pre) => {
      pre = pre?.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });

    setShowDropDown(false);
    setShowAllProjectsDropDown(false);
    setShowAllErrorMessageDropDown(false);
    setDropDownProjectSearch("");
    setDropDownErrorMessageSearch("");
    setSelectedListDropDown([]);
    setSelectedErrorMessages([]);
    setSelectedProjects([]);
    setProjectId([]);
    setErrorMessages([]);
  }

  const debouncedFetchDropDownSearchProjects = debounce((e) => {
    if (showAllProjectsDropDown) {
      setDropDownProjectSearch(e.target.value);
      getProjects(e.target.value);
    }
  }, 800);

  const debouncedFetchDropDownSearchErrorMessage = debounce((e) => {
    if (showAllErrorMessageDropDown) {
      setDropDownErrorMessageSearch(e.target.value);
      getErrorMessage(e.target.value);
    }
  }, 800);

  useEffect(() => {
    let arr = [];

    arr = [
      {
        text: "Daily Reports",
        value: "Daily Reports",
        isSelected: true,
        key: 0,
      },
      {
        text: "API",
        value: "API",
        isSelected: true,
        key: 0,
      },
      {
        text: "RazorPay To Token",
        value: "RazorPay To Token",
        isSelected: true,
        key: 0,
      },
      {
        text: "Daily Settlement",
        value: "Daily Settlement",
        isSelected: true,
        key: 0,
      },
    ];
    setTabs(arr);
    setTabValue(navigateTab !== "" ? navigateTab : arr[0]?.value);
  }, []);

  useEffect(() => {
    let arr = [];
    let currTab = "";

    if (tabValue === "API") {
      arr = [
        {
          text: "API Success",
          value: "API Success",
          isSelected: true,
          key: 0,
        },
        {
          text: "BRS Success",
          value: "BRS Success",
          isSelected: false,
          key: 0,
        },
        {
          text: "API Error",
          value: "API Error",
          isSelected: true,
          key: 0,
        },
        {
          text: "BRS Error",
          value: "BRS Error",
          isSelected: false,
          key: 0,
        },

        {
          text: "VJ Pending",
          value: "VJ Pending",
          isSelected: false,
          key: 0,
        },
        {
          text: "Landowner",
          value: "Landowner",
          isSelected: false,
          key: 0,
        },
      ];
      setSubTabs(arr);
      currTab = arr[0]?.value;
      setSubTabValue(navigateSubTab !== "" ? navigateSubTab : currTab);
    }

    if (tabValue === "RazorPay To Token") {
      arr = [
        {
          text: "API Success",
          value: "API Success",
          isSelected: true,
          key: 0,
        },
        {
          text: "BRS Success",
          value: "BRS Success",
          isSelected: false,
          key: 0,
        },
        {
          text: "API Error",
          value: "API Error",
          isSelected: true,
          key: 0,
        },
        {
          text: "BRS Error",
          value: "BRS Error",
          isSelected: false,
          key: 0,
        },
      ];
      setSubTabs(arr);
      currTab = arr[0]?.value;
      setSubTabValue(navigateSubTab !== "" ? navigateSubTab : currTab);
    }

    if (tabValue === "Daily Settlement") {
      arr = [
        {
          text: "API Success",
          value: "API Success",
          isSelected: true,
          key: 0,
        },
        {
          text: "BRS Success",
          value: "BRS Success",
          isSelected: false,
          key: 0,
        },
      ];
      setSubTabs(arr);
      currTab = arr[0]?.value;
      setSubTabValue(navigateSubTab !== "" ? navigateSubTab : currTab);
    }
  }, [tabValue]);

  useEffect(() => {
    getDailyReport();
    getAPIData();
    getRazorPayData();
    getSettlementData();
  }, []);

  useEffect(() => {
    if (tabValue === "API") {
      getAPIData();
      navigate(getURL() + `/${tabValue}/${subTabValue}/${paramAPIFilter}`);
    }
  }, [selectedAPIType, subTabValue]);

  useEffect(() => {
    if (tabValue === "RazorPay To Token") {
      getRazorPayData();
      navigate(getURL() + `/${tabValue}/${subTabValue}/${paramRazorPayFilter}`);
    }
  }, [selectedRazorPayType, subTabValue]);

  useEffect(() => {
    if (tabValue === "Daily Settlements") {
      getSettlementData();
      navigate(
        getURL() + `/${tabValue}/${subTabValue}/${paramSettlementFilter}`
      );
    }
  }, [selectedSettlementType, subTabValue]);

  useEffect(() => {
    if (tabValue === "Daily Reports") {
      navigate(getURL());
    }
    // else if(!subTabValue){
    //     navigate(`/home/APIDailyReports/${tabValue}/${subTabs[0]?.value}/`)

    // }else{
    //     navigate(`/home/APIDailyReports/${tabValue}/${subTabValue}/`)

    // }
  }, [tabValue]);

  useEffect(() => {
    getDailyReport();
    getAPIData();
    getRazorPayData();
    getSettlementData();
  }, [tabValue, projectId, lead, closedDate]);

  const tabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue !== "Daily Reports") {
      navigate(getURL() + `/${newValue}/${subTabs[0]?.value}`);
    }
    setNavigateTab("");
  };

  const subTabChange = (event, newValue) => {
    setSubTabValue(newValue);
    if (newValue !== "Daily Reports") {
      navigate(getURL() + `/${tabValue}/${newValue}`);
    }
    setNavigateSubTab("");
  };

  const debouncedFetchLead = debounce((e) => {
    setLead(e.target.value);
  }, 800);

  const getProjects = (search) => {
    supabase
      .from("Projects")
      .select("projectId,projectName")
      .eq("isVJ", true)
      .then((resp) => {
        let tempArray = allProjectsDropDown;
        tempArray = resp?.data?.map((el, index) => {
          return {
            label: el.projectName,
            value: false,
            id: el.projectId,
          };
        });
        const sortedProjects = orderBy(
          tempArray,
          [(project) => project.label.toLowerCase()],
          ["asc"]
        );

        const filterBySearch = search
          ? sortedProjects.filter((object) =>
            object.label.toLowerCase().includes(search.toLowerCase())
          )
          : sortedProjects;
        setAllProjectsDropDown(filterBySearch);
      })
      .catch((err) => {
        console.log(err);
        dismissLoader();
      });
  };

  async function getErrorMessage(search) {
    const newType = () => {
      if (tabValue === "API") {
        const newType =
          selectedAPIType.length !== 0
            ? selectedAPIType?.map((el) => el.name)
            : [
              "JV",
              "CustomerLedger",
              "100B2b",
              "gstB2b",
              "sdrB2b",
              "ApplicationApi",
              "100AMR",
              "gstAMR",
              "gstAMRBrs",
              "100AMRBrs",
            ];

        return newType;
      }
      // else if(tabValue === "RazorPay To Token"){

      //     const newType = selectedRazorPayType.length !== 0 ? selectedRazorPayType?.map(el=> el.name) : ["paymentReceivedInRazorpay","paymentReceivedInRazorpayBrs"]

      //   return newType
      // }
    };

    const postData =
      projectId.length > 0
        ? Object(
          lead === ""
            ? {
              date: DailyReportDate,
              type: newType(),
              projectId: projectId,
            }
            : {
              date: DailyReportDate,
              type: newType(),
              projectId: projectId,
              leadName: lead,
            }
        )
        : Object(
          lead === ""
            ? {
              date: DailyReportDate,
              type: newType(),
            }
            : {
              date: DailyReportDate,
              type: newType(),
              leadName: lead,
            }
        );

    if (tabValue === "API") {
      getAPILogs(postData)
        .then((res) => {
          let tempArray = allErrorMessageDropDown;

          const errorArrayData = Object.values(res.data)
            ?.map((data) => data?.Error)
            ?.flat();

          const errorMsgArray = errorArrayData
            .map((el) => {
              if (!el?.errorObj?.error?.errors && el?.errorObj?.error) {
                return el?.errorObj?.error;
              } else if (!el?.errorObj?.err?.errors && el?.errorObj?.err) {
                return el?.errorObj?.err;
              } else if (el?.errorObj?.err?.errors) {
                return el?.errorObj.err.errors?.map((el) => el?.code);
              } else if (el?.errorObj?.error?.errors) {
                return el?.errorObj?.error?.errors?.map((el) => el?.code);
              } else {
              }
            })
            ?.flat()
            .filter((element) => element !== undefined);

          const uniqueErrorMsgArray = Array.from(new Set(errorMsgArray));

          tempArray = uniqueErrorMsgArray?.map((el, index) => {
            return {
              label: el,
              value: false,
            };
          });

          const sortedErrorMsgs = orderBy(
            tempArray,
            [(errorMsg) => errorMsg?.label?.toLowerCase()],
            ["asc"]
          );

          const filterBySearch = search
            ? sortedErrorMsgs.filter((object) =>
              object.label.toLowerCase().includes(search.toLowerCase())
            )
            : sortedErrorMsgs;

          setAllErrorMessageDropDown(filterBySearch);
        })
        .catch((err) => {
          console.error(err);
          dismissLoader();
        });
    }
  }
  useEffect(() => {
    // getAPIData()

    getProjects();
    getErrorMessage();
  }, []);

  useEffect(() => {
    getErrorMessage();
  }, [tabValue]);

  const handleNavigation = (type, newTabValue) => {
    if (newTabValue === "Success API") {
      if (type === "paymentrecievedAPIBRS" || type === "paymentrecievedAPI") {
        setNavigateTab("RazorPay To Token");
        setTabValue("RazorPay To Token");

        if (type === "paymentrecievedAPI") {
          setSubTabValue("API Success");
          setNavigateSubTab("API Success");
          setSelectedRazorPayType([
            {
              id: "paymentReceivedInRazorpay",
              name: "paymentReceivedInRazorpay",
              filter: "cp",
            },
          ]);

          navigate(
            getURL() +
            `/${"RazorPay To Token"}/${"API Success"}/${"paymentReceivedInRazorpay"}`
          );
        } else if (type === "paymentrecievedAPIBRS") {
          setSubTabValue("BRS Success");
          setNavigateSubTab("BRS Success");
          setSelectedRazorPayType([
            {
              id: "paymentReceivedInRazorpayBrs",
              name: "paymentReceivedInRazorpayBrs",
              filter: "cp",
            },
          ]);

          navigate(
            getURL() +
            `/${"RazorPay To Token"}/${"BRS Success"}/${"paymentReceivedInRazorpayBrs"}`
          );
        }
      } else if (
        type === "paymentsettledAPI" ||
        type === "paymentsettledAPIBRS"
      ) {
        setNavigateTab("Daily Settlement");
        setTabValue("Daily Settlement");

        if (type === "paymentsettledAPI") {
          setSubTabValue("API Success");
          setNavigateSubTab("API Success");
          setSelectedSettlementType([
            {
              id: "Settlement",
              name: "Settlement",
              filter: "cp",
            },
          ]);
          navigate(
            getURL() + `/${"Daily Settlement"}/${"API Success"}/${"Settlement"}`
          );
        } else if (type === "paymentsettledAPIBRS") {
          setSubTabValue("BRS Success");
          setNavigateSubTab("BRS Success");
          setSelectedSettlementType([
            {
              id: "SettlementBrs",
              name: "SettlementBrs",
              filter: "cp",
            },
          ]);
          navigate(
            getURL() +
            `/${"Daily Settlement"}/${"BRS Success"}/${"SettlementBrs"}`
          );
        }
      } else if (
        type !== "paymentsettledAPI" &&
        type !== "paymentsettledAPIBRS" &&
        type !== "paymentrecievedAPIBRS" &&
        type !== "paymentrecievedAPI"
      ) {
        setTabValue("API");
        setNavigateTab("API");

        if (type === "100AMRBrs" || type === "gstAMRBrs") {
          setSubTabValue("BRS Success");
          setNavigateSubTab("BRS Success");
          setSelectedAPIType([
            {
              id: type,
              name: type,
              filter: "cp",
            },
          ]);
          const newType = type;
          navigate(getURL() + `/${"API"}/${"BRS Success"}/${newType}`);
        } else {
          setSubTabValue("API Success");
          setNavigateSubTab("API Success");
          setSelectedAPIType([
            {
              id: type,
              name: type,
              filter: "cp",
            },
          ]);
          const newType = type;

          navigate(getURL() + `/${"API"}/${"API Success"}/${newType}`);
        }
      }
    }
    if (newTabValue === "Error API") {
      if (
        type !== "paymentsettledAPI" &&
        type !== "paymentsettledAPIBRS" &&
        type !== "paymentrecievedAPIBRS" &&
        type !== "paymentrecievedAPI"
      ) {
        setTabValue("API");
        setNavigateTab("API");

        if (type === "100AMRBrs" || type === "gstAMRBrs") {
          setSubTabValue("BRS Error");
          setNavigateSubTab("BRS Error");
          setSelectedAPIType([
            {
              id: type,
              name: type,
              filter: "cp",
            },
          ]);
          const newType = type;
          navigate(getURL() + `/${"API"}/${"BRS Error"}/${newType}`);
        } else {
          setSubTabValue("API Error");
          setNavigateSubTab("API Error");
          setSelectedAPIType([
            {
              id: type,
              name: type,
              filter: "cp",
            },
          ]);
          const newType = type;
          navigate(getURL() + `/${"API"}/${"API Error"}/${newType}`);
        }
      } else {
        setTabValue("RazorPay To Token");
        setNavigateTab("RazorPay To Token");

        if (type === "paymentrecievedAPIBRS") {
          setSubTabValue("BRS Error");
          setNavigateSubTab("BRS Error");
          setSelectedRazorPayType([
            {
              id: "paymentReceivedInRazorpayBrs",
              name: "paymentReceivedInRazorpayBrs",
              filter: "cp",
            },
          ]);
          navigate(
            getURL() +
            `/${"RazorPay To Token"}/${"BRS Error"}/${"paymentReceivedInRazorpayBrs"}`
          );
        } else if (type === "paymentrecievedAPI") {
          setSubTabValue("API Error");
          setNavigateSubTab("API Error");
          setSelectedRazorPayType([
            {
              id: "paymentReceivedInRazorpay",
              name: "paymentReceivedInRazorpay",
              filter: "cp",
            },
          ]);
          navigate(
            getURL() +
            `/${"RazorPay To Token"}/${"API Error"}/${"paymentReceivedInRazorpay"}`
          );
        }
      }
    }

    if (newTabValue === "vjPending") {
      if (
        type !== "paymentsettledAPI" &&
        type !== "paymentsettledAPIBRS" &&
        type !== "paymentrecievedAPIBRS" &&
        type !== "paymentrecievedAPI"
      ) {
        setTabValue("API");
        setNavigateTab("API");
        setSubTabValue("VJ Pending");
        setNavigateSubTab("VJ Pending");
        setSelectedAPIType([
          {
            id: type,
            name: type,
            filter: "cp",
          },
        ]);
        const newType = type;
        navigate(getURL() + `/${"API"}/${"VJ Pending"}/${newType}`);
      }
    }

    if (newTabValue === "landowner") {
      if (
        type !== "paymentsettledAPI" &&
        type !== "paymentsettledAPIBRS" &&
        type !== "paymentrecievedAPIBRS" &&
        type !== "paymentrecievedAPI"
      ) {
        setTabValue("API");
        setNavigateTab("API");
        setSubTabValue("Landowner");
        setNavigateSubTab("Landowner");
        setSelectedAPIType([
          {
            id: type,
            name: type,
            filter: "cp",
          },
        ]);
        const newType = type;
        navigate(getURL() + `/${"API"}/${"Landowner"}/${newType}`);
      }
    }
  };

  useEffect(() => { }, [navigateTab, navigateSubTab]);

  return (
    <div className={cssClasses.mainContainer}>
      {tabs.length > 0 && (
        <>
          <div style={{ marginBottom: "2rem" }}>
            <div className={cssClasses.filterMainContainer}>
              <Box className={cssClasses.filterSubContainerA}>
                <div className={cssClasses.wrapperFilter}>
                  <p style={{ fontSize: "1.5rem" }}>Filter By: </p>
                  <div className={cssClasses.wrapperDropDown}>
                    <div
                      className={cssClasses.wrapperCustomiseDropDown}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDropDown(!showDropDown);
                      }}
                    >
                      <div className={cssClasses.dropDownLabel}>
                        <span className={cssClasses.dropDownLabelValue}>
                          {selectedListDropDown.join()}
                        </span>
                        {selectedListDropDown.length === 0 && (
                          <span className={cssClasses.dropDownLabelValue}>
                            None
                          </span>
                        )}
                      </div>

                      {showDropDown && (
                        <KeyboardArrowUpIcon
                          className={cssClasses.dropDownIcon}
                        />
                      )}
                      {showDropDown === false && (
                        <KeyboardArrowDownIcon
                          className={cssClasses.dropDownIcon}
                        />
                      )}
                    </div>

                    {showDropDown && (
                      <ClickAwayListener
                        onClickAway={() => {
                          setShowDropDown(false);
                        }}
                      >
                        <div
                          className={
                            cssClasses.containerCustomiseDropDownReports
                          }
                        >
                          <div className={cssClasses.wrapperSelectAndCheckbox}>
                            <div
                              className={cssClasses.wrapperEachSelectReports}
                            >
                              {listOfDropDown.map((each, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={
                                      each.select
                                        ? cssClasses.selectedVal
                                        : cssClasses.containerEachSelect
                                    }
                                  >
                                    <div
                                      className={cssClasses.eachSelect}
                                      onClick={() => {
                                        setListOfDropDown((pre) => {
                                          pre = pre.map((m) => ({
                                            ...m,
                                            select: false,
                                          }));
                                          // pre[index].select = true;
                                          return [...pre];
                                        });

                                        allProjectsDropDown?.forEach((el) => {
                                          if (el.value) {
                                            setListOfDropDown((pre) => {
                                              let indexOfMainList = findIndex(
                                                listOfDropDown,
                                                ({ label }) =>
                                                  label === "Project"
                                              );
                                              pre[
                                                indexOfMainList
                                              ].select = true;
                                              return [...pre];
                                            });
                                          }
                                        });
                                        allErrorMessageDropDown.forEach(
                                          (el) => {
                                            if (el.value) {
                                              let indexOfMainList = findIndex(
                                                listOfDropDown,
                                                ({ label }) =>
                                                  label === "Error Message"
                                              );
                                              setListOfDropDown((pre) => {
                                                pre[
                                                  indexOfMainList
                                                ].select = true;
                                                return [...pre];
                                              });
                                            }
                                          }
                                        );

                                        if (each.label === "None") {
                                          setSelectedListDropDown([]);

                                          setSelectedProjects([]);
                                          setSelectedErrorMessages([]);
                                          setProjectId([]);
                                          setErrorMessages([]);
                                          setListOfDropDown((pre) => {
                                            pre = pre.map((m) => ({
                                              ...m,
                                              select: false,
                                            }));
                                            pre[0].select = true;
                                            return [...pre];
                                          });

                                          allProjectsDropDown.forEach((el) => {
                                            el.value = false;
                                          });
                                          allErrorMessageDropDown.forEach(
                                            (el) => {
                                              el.value = false;
                                            }
                                          );

                                          setShowAllProjectsDropDown(false);
                                          setShowAllErrorMessageDropDown(false);
                                        } else if (each.label === "Project") {
                                          setTimeout(() => {
                                            let _va = document.getElementById(
                                              "input-with-icon-textfield DropDownProjectsSearch"
                                            );
                                            if (_va) {
                                              _va.value = DropdownProjectSearch;
                                            }
                                          }, 100);

                                          setShowAllProjectsDropDown(true);
                                          setShowAllErrorMessageDropDown(false);
                                        } else if (
                                          each.label === "Error Message"
                                        ) {
                                          setTimeout(() => {
                                            let _va = document.getElementById(
                                              "input-with-icon-textfield DropDownErrorMessagesSearch"
                                            );
                                            if (_va) {
                                              _va.value =
                                                DropdownErrorMessageSearch;
                                            }
                                          }, 100);

                                          setShowAllProjectsDropDown(false);
                                          setShowAllErrorMessageDropDown(true);
                                        }
                                      }}
                                    >
                                      {each.label}
                                    </div>
                                    {each.select && (
                                      <img
                                        src={checked}
                                        alt={"checked"}
                                        style={{ marginRight: "2rem" }}
                                      />
                                    )}
                                  </div>
                                );
                              })}
                            </div>

                            <div className={cssClasses.wrapperCheckbox1}>
                              {showAllProjectsDropDown && (
                                <Box width={"100%"} mb={2}>
                                  <SearchBar
                                    id={"DropDownProjectsSearch"}
                                    placeholder={"Search"}
                                    search={
                                      debouncedFetchDropDownSearchProjects
                                    }
                                    width="100%"
                                  />
                                </Box>
                              )}
                              {showAllErrorMessageDropDown && (
                                <Box width={"100%"} mb={2}>
                                  <SearchBar
                                    id={"DropDownErrorMessagesSearch"}
                                    placeholder={"Search"}
                                    search={
                                      debouncedFetchDropDownSearchErrorMessage
                                    }
                                    width="100%"
                                  />
                                </Box>
                              )}
                              <div className={cssClasses.wrapperCheckbox}>
                                {showAllProjectsDropDown && (
                                  <>
                                    {allProjectsDropDown?.length > 0 ? (
                                      allProjectsDropDown?.map(
                                        (each, index) => {
                                          return (
                                            <FormGroup key={index}>
                                              <FormControlLabel
                                                sx={[
                                                  {
                                                    "& .MuiTypography-root": {
                                                      fontFamily:
                                                        "Inter-Medium !important",
                                                      fontStyle: "normal",
                                                      fontWeight: "400",
                                                      fontSize:
                                                        "1.6rem !important",
                                                      lineHeight:
                                                        "2.4rem !important",
                                                      /* identical to box height, or 150% */

                                                      /* Gray/900 */

                                                      color: "#101828",
                                                    },
                                                  },
                                                ]}
                                                checked={each?.value}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setAllProjectsDropDown(
                                                      (pre) => {
                                                        pre[index].value =
                                                          e.target.checked;
                                                        selectedProjects.push(
                                                          each
                                                        );
                                                        return [...pre];
                                                      }
                                                    );
                                                  } else {
                                                    setAllProjectsDropDown(
                                                      (pre) => {
                                                        pre[index].value =
                                                          e.target.checked;
                                                        return [...pre];
                                                      }
                                                    );
                                                    setSelectedProjects(
                                                      selectedProjects.filter(
                                                        (label) =>
                                                          label !== each.label
                                                      )
                                                    );
                                                  }
                                                  let checkProjectSelected =
                                                    allProjectsDropDown.filter(
                                                      ({ value }) =>
                                                        value === true
                                                    );
                                                  let indexOfMainList =
                                                    findIndex(
                                                      listOfDropDown,
                                                      ({ label }) =>
                                                        label === "Project"
                                                    );
                                                  if (
                                                    checkProjectSelected.length >
                                                    0
                                                  ) {
                                                    setListOfDropDown((pre) => {
                                                      pre[
                                                        indexOfMainList
                                                      ].select = true;
                                                      return [...pre];
                                                    });
                                                    if (
                                                      selectedListDropDown.find(
                                                        (value) =>
                                                          value === "Project"
                                                      ) === undefined
                                                    ) {
                                                      selectedListDropDown.push(
                                                        "Project"
                                                      );
                                                    }
                                                  } else {
                                                    setListOfDropDown((pre) => {
                                                      pre[
                                                        indexOfMainList
                                                      ].select = false;
                                                      return [...pre];
                                                    });
                                                    setSelectedListDropDown([
                                                      ...selectedListDropDown.filter(
                                                        (value) =>
                                                          value !== "Project"
                                                      ),
                                                    ]);
                                                  }
                                                }}
                                                control={
                                                  <Checkbox
                                                    sx={{
                                                      "& .MuiSvgIcon-root": {
                                                        fontSize: 28,
                                                      },
                                                    }}
                                                  />
                                                }
                                                label={each.label}
                                              />
                                            </FormGroup>
                                          );
                                        }
                                      )
                                    ) : (
                                      <div className={cssClasses.label}>
                                        No Projects Found
                                      </div>
                                    )}
                                  </>
                                )}

                                {showAllErrorMessageDropDown && (
                                  <>
                                    {allErrorMessageDropDown?.length > 0 ? (
                                      allErrorMessageDropDown?.map(
                                        (each, index) => {
                                          return (
                                            <FormGroup key={index}>
                                              <FormControlLabel
                                                sx={[
                                                  {
                                                    "& .MuiTypography-root": {
                                                      fontFamily:
                                                        "Inter-Medium !important",
                                                      fontStyle: "normal",
                                                      fontWeight: "400",
                                                      fontSize:
                                                        "1.6rem !important",
                                                      lineHeight:
                                                        "2.4rem !important",
                                                      /* identical to box height, or 150% */

                                                      /* Gray/900 */

                                                      color: "#101828",
                                                    },
                                                  },
                                                ]}
                                                checked={each?.value}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setAllErrorMessageDropDown(
                                                      (pre) => {
                                                        pre[index].value =
                                                          e.target.checked;
                                                        selectedErrorMessages.push(
                                                          each
                                                        );
                                                        return [...pre];
                                                      }
                                                    );
                                                  } else {
                                                    setAllErrorMessageDropDown(
                                                      (pre) => {
                                                        pre[index].value =
                                                          e.target.checked;
                                                        return [...pre];
                                                      }
                                                    );
                                                    setSelectedErrorMessages(
                                                      selectedErrorMessages.filter(
                                                        (label) =>
                                                          label !== each.label
                                                      )
                                                    );
                                                  }
                                                  let checkErrorMessageSelected =
                                                    allErrorMessageDropDown.filter(
                                                      ({ value }) =>
                                                        value === true
                                                    );
                                                  let indexOfMainList =
                                                    findIndex(
                                                      listOfDropDown,
                                                      ({ label }) =>
                                                        label ===
                                                        "Error Message"
                                                    );
                                                  if (
                                                    checkErrorMessageSelected.length >
                                                    0
                                                  ) {
                                                    setListOfDropDown((pre) => {
                                                      pre[
                                                        indexOfMainList
                                                      ].select = true;
                                                      return [...pre];
                                                    });
                                                    if (
                                                      selectedListDropDown.find(
                                                        (value) =>
                                                          value ===
                                                          "Error Message"
                                                      ) === undefined
                                                    ) {
                                                      selectedListDropDown.push(
                                                        "Error Message"
                                                      );
                                                    }
                                                  } else {
                                                    setListOfDropDown((pre) => {
                                                      pre[
                                                        indexOfMainList
                                                      ].select = false;
                                                      return [...pre];
                                                    });
                                                    setSelectedListDropDown([
                                                      ...selectedListDropDown.filter(
                                                        (value) =>
                                                          value !==
                                                          "Error Message"
                                                      ),
                                                    ]);
                                                  }
                                                }}
                                                control={
                                                  <Checkbox
                                                    sx={{
                                                      "& .MuiSvgIcon-root": {
                                                        fontSize: 28,
                                                      },
                                                    }}
                                                  />
                                                }
                                                label={each.label}
                                              />
                                            </FormGroup>
                                          );
                                        }
                                      )
                                    ) : (
                                      <div className={cssClasses.label}>
                                        No Error Messages Found
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                              <div
                                className={cssClasses.wrapperDropDownButtons}
                              >
                                <div>
                                  <Button
                                    style={{
                                      color: "#344054",
                                      backgroundColor: "#ffffff",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                    }}
                                    padding={"0.8rem"}
                                    btnName={"Clear"}
                                    clicked={() => {
                                      clearFilters();
                                    }}
                                  />
                                </div>
                                <div>
                                  <Button
                                    style={{
                                      color: "#ffffff",
                                      backgroundColor: "#1570EF",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                    }}
                                    padding={"0.8rem"}
                                    btnName={"Apply"}
                                    clicked={() => {
                                      setShowAllProjectsDropDown(false);
                                      setShowAllErrorMessageDropDown(false);
                                      setShowDropDown(false);

                                      const projectsIdArray = Array.from(
                                        new Set(
                                          selectedProjects
                                            .filter((el) => el.value)
                                            ?.map((el) => el.id)
                                        )
                                      );

                                      setProjectId(projectsIdArray);
                                      const errorMessagesArray = Array.from(
                                        new Set(
                                          selectedErrorMessages
                                            .filter((el) => el.value)
                                            ?.map((el) => el.label)
                                        )
                                      );
                                      setErrorMessages(errorMessagesArray);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ClickAwayListener>
                    )}
                  </div>
                </div>
                <div className={cssClasses.wrapperFilter}>
                  <p style={{ fontSize: "1.5rem" }}>Date: </p>
                  {/*<Box
                    style={{
                      fontSize: "1.2rem",
                      marginTop: "1rem",
                      minWidth: "180px",
                      maxWidth: "180px",
                      padding: "1.8rem 0rem !important",
                    }}
                  >
                     <MobileDateComponent
                    helperText={helperText?.startDateTime}
                    label={`Date :`}
                    minDate={new Date("01/01/1970")}
                    maxDate={new Date()}
                    onChangeDate={(e) => {
                      const currentDate = new Date(e);
                      const day = String(currentDate.getDate()).padStart(
                        2,
                        "0"
                      );
                      const month = String(currentDate.getMonth() + 1).padStart(
                        2,
                        "0"
                      ); // Months are zero-indexed
                      const year = currentDate.getFullYear();

                      const formattedChangedDate = `${year}-${month}-${day}`;

                      setDailyReportDate(formattedChangedDate);
                    }}
                    onCloseDate={(e) => {
                      setClosedDate(Date.now());
                    }}
                    value={DailyReportDate}
                  /> */}
                  <Box className={cssClasses.wrapperDropDown}>

                    <input type="date"
                      className={cssClasses.wrapperCustomiseDropDown}
                      min={new Date("01/01/2023")}
                      max={new Date()}
                      defaultValue={DailyReportDate}
                      onChange={(e) => {
                        setDailyReportDate(e.target.value);
                        setClosedDate(Date.now());
                      }} />
                  </Box>
                  {/* </Box> */}
                </div>
              </Box>

              <div
                className={cssClasses.filterSubContainerB}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "1rem",
                  width: "40rem",
                }}
              >
                <p style={{ fontSize: "1.5rem" }}>Lead : </p>
                <SearchBar
                  width={"40rem"}
                  placeholder={"Search By Lead Name"}
                  search={debouncedFetchLead}
                />
              </div>
            </div>

            <div className={cssClasses.tabsWrapper} style={{ height: "100%" }}>
              <Box
                className={cssClasses.TabsWrapper}
                style={{ height: "100%" }}
              >
                <TabContext value={tabs?.find((f) => f.isSelected)?.value}>
                  <TabsMenu
                    selectedColor={"#1570EF"}
                    selectedBackgroundColor={"#FFFFFF"}
                    stylesForTab={{
                      color: "#344054",
                      fontSize: "1.6rem",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "2.4rem",
                      padding: "0.8rem 1.2rem",
                      textTransform: "unset",
                      borderBottom: "1px solid #EAECF0",
                    }}
                    borderColor={"#1570EFs"}
                    stylesForWrapper={{
                      // padding: "1.5rem 0",
                      background: "#FFFFFF",
                    }}
                    list={tabs}
                    value={
                      navigateTab !== "" && tabValue !== "Daily Reports"
                        ? navigateTab
                        : tabs.find((f) => f.isSelected).value
                    }
                    handleChange={(e, value) => {
                      tabChange(e, value);
                      setTabs((pre) => {
                        pre.forEach((ele) => {
                          if (ele.value === value) {
                            ele.isSelected = true;
                          } else {
                            ele.isSelected = false;
                          }
                        });
                        return [...pre];
                      });
                    }}
                  />
                  <div className={cssClasses.salesTable}>
                    {tabValue === "Daily Reports" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "90vw",
                          gap: "3rem",
                        }}
                      >
                        <Table
                          sx={{
                            overflowX: "auto",
                            ".MuiTableHead-root": {
                              background: "#F9FAFB",
                              border: "1px solid #E5E7EB",
                            },
                            ".MuiTableCell-root": {
                              fontSize: "1.4rem",
                              whiteSpace: "nowrap",
                            },
                            ".MuiTableRow-root": {
                              border: "1px solid #E5E7EB",
                            },
                          }}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                style={{
                                  minWidth: "150px",
                                  wordBreak: "break-word",
                                }}
                              >
                                API
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{
                                  minWidth: "150px",
                                  wordBreak: "break-word",
                                }}
                              >
                                Success Count
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{
                                  minWidth: "150px",
                                  wordBreak: "break-word",
                                }}
                              >
                                Error Count
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{
                                  minWidth: "150px",
                                  wordBreak: "break-word",
                                }}
                              >
                                Vj Pending
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{
                                  minWidth: "150px",
                                  wordBreak: "break-word",
                                }}
                              >
                                Landowner
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Object.keys(dailyReports)?.map((APIType, i) => (
                              <TableRow
                                key={i}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {APIType}
                                </TableCell>

                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  <div
                                    style={{ display: "flex", gap: "0.8rem" }}
                                  >
                                    <p
                                      style={{
                                        MinWidth: "3rem",
                                        textAlign: "right",
                                      }}
                                    >
                                      {dailyReports[APIType].Success}
                                    </p>
                                    {dailyReports[APIType].Success !== 0 && (
                                      <OpenInNewIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleNavigation(
                                            APIType,
                                            "Success API"
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                </TableCell>

                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  <div
                                    style={{ display: "flex", gap: "0.8rem" }}
                                  >
                                    {" "}
                                    <p
                                      style={{
                                        MinWidth: "3rem",
                                        textAlign: "right",
                                      }}
                                    >
                                      {dailyReports[APIType].Error}
                                    </p>
                                    {dailyReports[APIType].Error !== 0 && (
                                      <OpenInNewIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleNavigation(APIType, "Error API")
                                        }
                                      />
                                    )}
                                  </div>
                                </TableCell>

                                {dailyReports[APIType]["Pending From VJ"] ? (
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <div
                                      style={{ display: "flex", gap: "0.8rem" }}
                                    >
                                      <p
                                        style={{
                                          MinWidth: "3rem",
                                          textAlign: "right",
                                        }}
                                      >
                                        {
                                          dailyReports[APIType][
                                          "Pending From VJ"
                                          ]
                                        }
                                      </p>
                                      <OpenInNewIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleNavigation(APIType, "vjPending")
                                        }
                                      />
                                    </div>
                                  </TableCell>
                                ) : dailyReports[APIType]["Pending From VJ"] ===
                                  0 ? (
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {" "}
                                    0{" "}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {" "}
                                    -{" "}
                                  </TableCell>
                                )}

                                {dailyReports[APIType].Landowner ? (
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {" "}
                                    <div
                                      style={{ display: "flex", gap: "0.8rem" }}
                                    >
                                      <p
                                        style={{
                                          MinWidth: "3rem",
                                          textAlign: "right",
                                        }}
                                      >
                                        {dailyReports[APIType].Landowner}{" "}
                                      </p>{" "}
                                      <OpenInNewIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleNavigation(APIType, "landowner")
                                        }
                                      />{" "}
                                    </div>
                                  </TableCell>
                                ) : dailyReports[APIType].Landowner === 0 ? (
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {" "}
                                    0{" "}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {" "}
                                    -{" "}
                                  </TableCell>
                                )}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </div>
                    )}

                    {tabValue === "API" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "92vw",
                        }}
                      >
                        <TabContext
                          value={subTabs?.find((f) => f.isSelected)?.value}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className={cssClasses.subTabHeader}>
                            {" "}
                            <TabsMenu
                              selectedColor={"#1570EF"}
                              selectedBackgroundColor={"#FFFFFF"}
                              stylesForTab={{
                                color: "#344054",
                                fontSize: "1.6rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "2.4rem",
                                padding: "0.8rem 1.2rem",
                                textTransform: "unset",
                                borderBottom: "1px solid #EAECF0",
                              }}
                              borderColor={"#1570EFs"}
                              stylesForWrapper={{
                                padding: "1.5rem 0",
                                background: "#FFFFFF",
                              }}
                              RemoveWidth={true}
                              list={subTabs}
                              value={
                                navigateSubTab !== "" && navigateTab !== ""
                                  ? navigateSubTab
                                  : subTabs.find((f) => f.isSelected)?.value
                              }
                              handleChange={(e, value) => {
                                subTabChange(e, value);
                                setSubTabs((pre) => {
                                  pre.forEach((ele) => {
                                    if (ele.value === value) {
                                      ele.isSelected = true;
                                    } else {
                                      ele.isSelected = false;
                                    }
                                  });
                                  return [...pre];
                                });
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                marginBottom: "1rem",
                              }}
                            >
                              <p>Type: </p>
                              <MultiSelectDropDown
                                list={typeList}
                                value={selectedAPIType}
                                placeHolder="Search by Type"
                                ReportDropDown={true}
                                handleChange={(e) => {
                                  const value = e?.target?.value;
                                  if (value !== "") {
                                    if (value[value?.length - 1] === "all") {
                                      setSelectedAPIType(
                                        selectedAPIType?.length ===
                                          typeList?.length
                                          ? []
                                          : typeList
                                      );
                                      return;
                                    }
                                    setSelectedAPIType(value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          {tabValue === "API" &&
                            subTabValue === "API Success" && (
                              <Table
                                sx={{
                                  overflowX: "auto",
                                  ".MuiTableHead-root": {
                                    background: "#F9FAFB",
                                    border: "1px solid #E5E7EB",
                                  },
                                  ".MuiTableCell-root": {
                                    fontSize: "1.4rem",
                                    whiteSpace: "wrap",
                                  },
                                  ".MuiTableRow-root": {
                                    border: "1px solid #E5E7EB",
                                  },
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Time
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Type
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Lead Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Project Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Success Response
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredSuccessArray.map((success, i) => (
                                    <TableRow
                                      key={i}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {success.created_at
                                          ? new Date(
                                            success.created_at
                                          ).toLocaleDateString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {success.created_at
                                          ? new Date(
                                            success.created_at
                                          ).toLocaleTimeString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {success?.type}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {success?.leadName || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {success?.projectName || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {success?.type === "CustomerLedger"
                                          ? success?.successObj.outputList
                                            ?.ledgerId
                                          : success?.successResponse || "-"}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            )}

                          {tabValue === "API" &&
                            subTabValue === "BRS Success" && (
                              <Table
                                sx={{
                                  overflowX: "auto",
                                  ".MuiTableHead-root": {
                                    background: "#F9FAFB",
                                    border: "1px solid #E5E7EB",
                                  },
                                  ".MuiTableCell-root": {
                                    fontSize: "1.4rem",
                                    whiteSpace: "wrap",
                                  },
                                  ".MuiTableRow-root": {
                                    border: "1px solid #E5E7EB",
                                  },
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Time
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Type
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Lead Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Project Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Success Response
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredBrsSuccessAPIArray.map(
                                    (success, i) => (
                                      <TableRow
                                        key={i}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {success.created_at
                                            ? new Date(
                                              success.created_at
                                            ).toLocaleDateString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {success.created_at
                                            ? new Date(
                                              success.created_at
                                            ).toLocaleTimeString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {success?.type}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {success?.leadName || "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {success?.projectName || "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {success?.type === "CustomerLedger"
                                            ? success?.successObj.outputList
                                              ?.ledgerId
                                            : success?.successResponse || "-"}
                                        </TableCell>
                                      </TableRow>
                                    )
                                  )}
                                </TableBody>
                              </Table>
                            )}

                          {tabValue === "API" &&
                            subTabValue === "API Error" && (
                              <Table
                                sx={{
                                  overflowX: "auto",
                                  ".MuiTableHead-root": {
                                    background: "#F9FAFB",
                                    border: "1px solid #E5E7EB",
                                  },
                                  ".MuiTableCell-root": {
                                    fontSize: "1.4rem",
                                    whiteSpace: "wrap",
                                  },
                                  ".MuiTableRow-root": {
                                    border: "1px solid #E5E7EB",
                                  },
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Time
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Message
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Response
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Type
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Lead Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Project Name
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Payload
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredErrorArray?.map((error, i) => (
                                    <TableRow
                                      key={i}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error.created_at
                                          ? new Date(
                                            error.created_at
                                          ).toLocaleDateString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error.created_at
                                          ? new Date(
                                            error.created_at
                                          ).toLocaleTimeString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.errorMsg || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {JSON.stringify(error?.errorObj) || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.type}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.leadName || "-"}

                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate("/home/Leads");
                                              sessionStorage.setItem(
                                                "LeadName",
                                                error?.leadName
                                              );
                                              sessionStorage.setItem(
                                                "LeadId",
                                                error?.id
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.projectName || "-"}{" "}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate(
                                                `/home/Projects/${error?.projectId}`
                                              );
                                              sessionStorage.setItem(
                                                "ProjectName",
                                                error?.projectName
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.payload ? (
                                          <Button
                                            style={{
                                              boxShadow: "none",
                                              border: "none",
                                              backgroundColor: "#ffffff",
                                              textDecoration: "underline",
                                              color: "#4089ef",
                                              fontSize: "1.2rem",
                                            }}
                                            btnName={"View Payload"}
                                            clicked={() => {
                                              setShowPayloadModal(true);
                                              setSendPayloadData({
                                                projectName: error?.projectName,
                                                leadName: error?.leadName,
                                                type: error?.type,
                                                payload: error?.payload,
                                              });
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            )}

                          {tabValue === "API" &&
                            subTabValue === "BRS Error" && (
                              <Table
                                sx={{
                                  overflowX: "auto",
                                  ".MuiTableHead-root": {
                                    background: "#F9FAFB",
                                    border: "1px solid #E5E7EB",
                                  },
                                  ".MuiTableCell-root": {
                                    fontSize: "1.4rem",
                                    whiteSpace: "wrap",
                                  },
                                  ".MuiTableRow-root": {
                                    border: "1px solid #E5E7EB",
                                  },
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Time
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        width: "200px",
                                        whiteSpace: "wrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Message
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Response
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Type
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Lead Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Project Name
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredBrsErrorArray?.map((error, i) => (
                                    <TableRow
                                      key={i}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.created_at
                                          ? new Date(
                                            error.created_at
                                          ).toLocaleDateString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error.created_at
                                          ? new Date(
                                            error.created_at
                                          ).toLocaleTimeString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.errorMsg || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.errorResponse || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.type}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.leadName || "-"}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate("/home/Leads");
                                              sessionStorage.setItem(
                                                "LeadName",
                                                error?.leadName
                                              );
                                              sessionStorage.setItem(
                                                "LeadId",
                                                error?.id
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.projectName || "-"}{" "}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate(
                                                `/home/Projects/${error?.projectId}`
                                              );
                                              sessionStorage.setItem(
                                                "ProjectName",
                                                error?.projectName
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            )}

                          {tabValue === "API" &&
                            subTabValue === "VJ Pending" && (
                              <Table
                                sx={{
                                  overflowX: "auto",
                                  ".MuiTableHead-root": {
                                    background: "#F9FAFB",
                                    border: "1px solid #E5E7EB",
                                  },
                                  ".MuiTableCell-root": {
                                    fontSize: "1.4rem",
                                    whiteSpace: "wrap",
                                  },
                                  ".MuiTableRow-root": {
                                    border: "1px solid #E5E7EB",
                                  },
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Time
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Message
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Response
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Type
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Lead Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Project Name
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredVjPendingArray?.map((error, i) => (
                                    <TableRow
                                      key={i}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.created_at
                                          ? new Date(
                                            error?.created_at
                                          ).toLocaleDateString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.created_at
                                          ? new Date(
                                            error?.created_at
                                          ).toLocaleTimeString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.errorMsg || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {JSON.stringify(error?.errorObj) || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.type}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.leadName || "-"}{" "}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate("/home/Leads");
                                              sessionStorage.setItem(
                                                "LeadName",
                                                error?.leadName
                                              );
                                              sessionStorage.setItem(
                                                "LeadId",
                                                error?.id
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.projectName || "-"}{" "}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate(
                                                `/home/Projects/${error?.projectId}`
                                              );
                                              sessionStorage.setItem(
                                                "ProjectName",
                                                error?.projectName
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            )}

                          {tabValue === "API" &&
                            subTabValue === "Landowner" && (
                              <Table
                                sx={{
                                  overflowX: "auto",
                                  ".MuiTableHead-root": {
                                    background: "#F9FAFB",
                                    border: "1px solid #E5E7EB",
                                  },
                                  ".MuiTableCell-root": {
                                    fontSize: "1.4rem",
                                    whiteSpace: "wrap",
                                  },
                                  ".MuiTableRow-root": {
                                    border: "1px solid #E5E7EB",
                                  },
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Date
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Time
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Message
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Error Response
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Type
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Lead Name
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Project Name
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      Payload
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredLandownerArray?.map((error, i) => (
                                    <TableRow
                                      key={i}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.created_at
                                          ? new Date(
                                            error?.created_at
                                          ).toLocaleDateString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.created_at
                                          ? new Date(
                                            error?.created_at
                                          ).toLocaleTimeString()
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.errorMsg || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {JSON.stringify(error?.errorObj) || "-"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.type}
                                      </TableCell>

                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.leadName || "-"}{" "}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate("/home/Leads");
                                              sessionStorage.setItem(
                                                "LeadName",
                                                error?.leadName
                                              );
                                              sessionStorage.setItem(
                                                "LeadId",
                                                error?.id
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "0.6rem",
                                          }}
                                        >
                                          {error?.projectName || "-"}{" "}
                                          <OpenInNewIcon
                                            onClick={() => {
                                              navigate(
                                                `/home/Projects/${error?.projectId}`
                                              );
                                              sessionStorage.setItem(
                                                "ProjectName",
                                                error?.projectName
                                              );
                                            }}
                                            sx={{
                                              fontSize: 25,
                                              verticalAlign: "middle",
                                              color: "#344054",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        style={{
                                          minWidth: "150px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {error?.payload ? (
                                          <Button
                                            style={{
                                              boxShadow: "none",
                                              border: "none",
                                              backgroundColor: "#ffffff",
                                              textDecoration: "underline",
                                              color: "#4089ef",
                                              fontSize: "1.2rem",
                                            }}
                                            btnName={"View Payload"}
                                            clicked={() => {
                                              setShowPayloadModal(true);
                                              setSendPayloadData({
                                                projectName: error?.projectName,
                                                leadName: error?.leadName,
                                                type: error?.type,
                                                payload: error?.payload,
                                              });
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            )}
                        </TabContext>
                      </div>
                    )}

                    {tabValue === "RazorPay To Token" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "92vw",
                        }}
                      >
                        <TabContext
                          value={subTabs?.find((f) => f.isSelected)?.value}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className={cssClasses.subTabHeader}>
                            {" "}
                            <TabsMenu
                              selectedColor={"#1570EF"}
                              selectedBackgroundColor={"#FFFFFF"}
                              stylesForTab={{
                                color: "#344054",
                                fontSize: "1.6rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "2.4rem",
                                padding: "0.8rem 1.2rem",
                                textTransform: "unset",
                                borderBottom: "1px solid #EAECF0",
                              }}
                              borderColor={"#1570EFs"}
                              stylesForWrapper={{
                                padding: "1.5rem 0",
                                background: "#FFFFFF",
                              }}
                              RemoveWidth={true}
                              list={subTabs}
                              value={
                                navigateSubTab !== "" && navigateTab !== ""
                                  ? navigateSubTab
                                  : subTabs.find((f) => f.isSelected)?.value
                              }
                              handleChange={(e, value) => {
                                subTabChange(e, value);
                                setSubTabs((pre) => {
                                  pre.forEach((ele) => {
                                    if (ele.value === value) {
                                      ele.isSelected = true;
                                    } else {
                                      ele.isSelected = false;
                                    }
                                  });
                                  return [...pre];
                                });
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                marginBottom: "1rem",
                                gap: "1.5rem",
                              }}
                            >
                              <p>Type: </p>
                              <MultiSelectDropDown
                                list={typeList}
                                value={selectedRazorPayType}
                                placeHolder="Search by Type"
                                ReportDropDown={true}
                                handleChange={(e) => {
                                  const value = e?.target?.value;
                                  if (value !== "") {
                                    if (value[value?.length - 1] === "all") {
                                      setSelectedRazorPayType(
                                        selectedRazorPayType?.length ===
                                          typeList?.length
                                          ? []
                                          : typeList
                                      );
                                      return;
                                    }

                                    setSelectedRazorPayType(value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <Table
                            sx={{
                              overflowX: "auto",
                              ".MuiTableHead-root": {
                                background: "#F9FAFB",
                                border: "1px solid #E5E7EB",
                              },
                              ".MuiTableCell-root": {
                                fontSize: "1.4rem",
                                whiteSpace: "wrap",
                                width: "200px",
                              },
                              ".MuiTableRow-root": {
                                border: "1px solid #E5E7EB",
                              },
                            }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Date
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Time
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Response
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Pay Id
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {tabValue === "RazorPay To Token" &&
                                subTabValue === "API Success" &&
                                paymentAPI?.Success?.map((el, i) => (
                                  <TableRow
                                    key={i}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    {paymentAPI?.Success?.length > 0 && ( // Check if there are errors
                                      <>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleDateString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleTimeString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.successResponse || "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.payId || "-"}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                ))}

                              {tabValue === "RazorPay To Token" &&
                                subTabValue === "BRS Success" &&
                                paymentBRS?.Success?.map((el, i) => (
                                  <TableRow
                                    key={i}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    {paymentBRS?.Success?.length > 0 && ( // Check if there are errors
                                      <>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleDateString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleTimeString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.successResponse || "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.payId || "-"}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                ))}
                              {tabValue === "RazorPay To Token" &&
                                subTabValue === "API Error" &&
                                paymentAPI?.Error?.map((Error, i) => (
                                  <TableRow
                                    key={i}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.created_at
                                        ? new Date(
                                          Error?.created_at
                                        ).toLocaleDateString()
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error.created_at
                                        ? new Date(
                                          Error?.created_at
                                        ).toLocaleTimeString()
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.type}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.errorMsg || "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.leadName || "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.projectName || "-"}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              {tabValue === "RazorPay To Token" &&
                                subTabValue === "BRS Error" &&
                                paymentBRS?.Error?.map((Error, i) => (
                                  <TableRow
                                    key={i}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.created_at
                                        ? new Date(
                                          Error?.created_at
                                        ).toLocaleDateString()
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error.created_at
                                        ? new Date(
                                          Error?.created_at
                                        ).toLocaleTimeString()
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.type}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.errorMsg || "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.leadName || "-"}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        minWidth: "150px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {Error?.projectName || "-"}
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TabContext>
                      </div>
                    )}

                    {tabValue === "Daily Settlement" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "92vw",
                        }}
                      >
                        <TabContext
                          value={subTabs?.find((f) => f.isSelected)?.value}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className={cssClasses.subTabHeader}>
                            {" "}
                            <TabsMenu
                              selectedColor={"#1570EF"}
                              selectedBackgroundColor={"#FFFFFF"}
                              stylesForTab={{
                                color: "#344054",
                                fontSize: "1.6rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "2.4rem",
                                padding: "0.8rem 1.2rem",
                                textTransform: "unset",
                                borderBottom: "1px solid #EAECF0",
                              }}
                              borderColor={"#1570EFs"}
                              stylesForWrapper={{
                                padding: "1.5rem 0",
                                background: "#FFFFFF",
                              }}
                              RemoveWidth={true}
                              list={subTabs}
                              value={
                                navigateSubTab !== "" && navigateTab !== ""
                                  ? navigateSubTab
                                  : subTabs.find((f) => f.isSelected)?.value
                              }
                              handleChange={(e, value) => {
                                subTabChange(e, value);
                                setSubTabs((pre) => {
                                  pre.forEach((ele) => {
                                    if (ele.value === value) {
                                      ele.isSelected = true;
                                    } else {
                                      ele.isSelected = false;
                                    }
                                  });
                                  return [...pre];
                                });
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                marginBottom: "1rem",
                                gap: "1.5rem",
                              }}
                            >
                              <p>Type: </p>
                              <MultiSelectDropDown
                                list={typeList}
                                value={selectedSettlementType}
                                placeHolder="Search by Type"
                                ReportDropDown={true}
                                handleChange={(e) => {
                                  const value = e?.target?.value;
                                  if (value !== "") {
                                    if (value[value?.length - 1] === "all") {
                                      setSelectedSettlementType(
                                        selectedSettlementType?.length ===
                                          typeList?.length
                                          ? []
                                          : typeList
                                      );
                                      return;
                                    }
                                    setSelectedSettlementType(value);
                                  }
                                }}
                              />
                            </div>
                          </div>

                          <Table
                            sx={{
                              overflowX: "auto",
                              ".MuiTableHead-root": {
                                background: "#F9FAFB",
                                border: "1px solid #E5E7EB",
                              },
                              ".MuiTableCell-root": {
                                fontSize: "1.4rem",
                                whiteSpace: "nowrap",
                              },
                              ".MuiTableRow-root": {
                                border: "1px solid #E5E7EB",
                              },
                            }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Date
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Time
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Response
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    minWidth: "150px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  Settlement URT
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {tabValue === "Daily Settlement" &&
                                subTabValue === "API Success" &&
                                settlementAPIData?.Success?.map((el, i) => (
                                  <TableRow
                                    key={i}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    {settlementAPIData?.Success?.length > 0 && ( // Check if there are errors
                                      <>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleDateString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleTimeString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.successResponse || "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.settlementUTR || "-"}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                ))}

                              {tabValue === "Daily Settlement" &&
                                subTabValue === "BRS Success" &&
                                settlementBRSData?.Success?.map((el, i) => (
                                  <TableRow
                                    key={i}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    {settlementBRSData?.Success?.length > 0 && ( // Check if there are errors
                                      <>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleDateString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.created_at
                                            ? new Date(
                                              el?.created_at
                                            ).toLocaleTimeString()
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.successResponse || "-"}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          style={{
                                            minWidth: "150px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {el?.settlementUTR || "-"}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TabContext>
                      </div>
                    )}
                  </div>
                </TabContext>
              </Box>
            </div>
          </div>
        </>
      )}

      {showPayloadModal && (
        <PayloadModal
          open={showPayloadModal}
          closeHandler={() => setShowPayloadModal(false)}
          projectName={sendPayloadData?.projectName}
          leadName={sendPayloadData?.leadName}
          type={sendPayloadData?.type}
          payload={sendPayloadData?.payload}
        />
      )}
    </div>
  );
}
